"use client";
import {useEffect, useState} from "react";
import {getCookie, setCookie} from "cookies-next";
import {fetchBanners} from "@/lib/legacyApi/fetchBanners";
import {useCookieCampusId} from "./contexts/CampusCookieContext";
import Banner from "../types/Banner";
import HelloBar from "./HelloBar";

/**
 * Gets the cookie key used for hiding a given banner
 * @param banner
 * @returns the cookie key for this banner
 */
function getBannerCookieKey(banner: Banner) {
	return `infobar-${banner.announcementId}-hide`;
}

const HelloBarWrapper: React.FC = () => {
	const campusId = useCookieCampusId();
	const [isVisible, setIsVisible] = useState<boolean>(false);
	const [banner, setBanner] = useState<Banner>();

	// On campus cookie change or page load, load the banner for this element
	useEffect(() => {
		fetchBanners(campusId ?? undefined).then((banners) => {
			if (!banners?.length) {
				return;
			}
			const firstBanner = banners[0];
			setBanner(firstBanner);

			const bannerCookieKey = getBannerCookieKey(firstBanner);
			const shouldBeVisible = getCookie(bannerCookieKey) !== "1";
			setIsVisible(shouldBeVisible);
		});
	}, [campusId]);

	/**
	 * When the close button is clicked, sets the cookie for this banner so it doesn't appear again for 24 hours
	 */
	const onCloseButtonClick = () => {
		if (!banner) {
			return;
		}

		setIsVisible(false);

		const expires = new Date();
		expires.setUTCDate(expires.getUTCDate() + 1);
		expires.setHours(0, 0, 0, 0);

		const bannerCookieKey = getBannerCookieKey(banner);
		setCookie(bannerCookieKey, "1", {expires});
	};

	return (
		<HelloBar
			banner={banner}
			isVisible={isVisible}
			onCloseButtonClick={onCloseButtonClick}
		/>
	);
};

export default HelloBarWrapper;
